import React from 'react';
import SubscriptionManagement from './SubscriptionManagement';
import './SubscriptionPage.css';

const SubscriptionPage = () => {
  return (
    <div className="subscription-container">
      <div className="subscription-header">
        <h1>Suscripción</h1>
        <p>Gestiona tu plan de suscripción y opciones de facturación</p>
      </div>

      <div className="subscription-content">
        <SubscriptionManagement />
      </div>
    </div>
  );
};

export default SubscriptionPage;
